<template>
  <div class="q-wrapper">
    <v-radio-group v-model="computedradioButtons" ref="group" :rules="rules" hide-details class="ma-0">
      <v-radio
        v-for="radio in radioGroup"
        :key="radio.id"
        :name="'radio' + groupId"
        :value="radio"
        :color="color"
        :disabled="disabled"
      >
        <template slot="label">
          <span class="subtitle-1">{{ radio.optionValue }}</span>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
export default {
  name: 'BDO-RadioButtonGroup',
  data: () => ({}),
  props: {
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    groupId: {
      type: Number,
      default: 0
    },
    radioGroup: {
      type: Array,
      default: () => []
    },
    selectedGroup: {
      type: Number,
      default: 0
    },
    selectedRadio: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'bdoRed'
    }
  },
  computed: {
    rules() {
      const rules = []
      const required = value => !!value || 'Field is required'
      if (this.required) {
        rules.push(required)
      }
      return rules
    },
    computedradioButtons: {
      get() {
        if (!helpers.isEmpty(this.selectedRadio)) {
          let obj = this.radioGroup.find(o => o.optionValue === this.selectedRadio)
          return obj
        } else if (this.value && this.value.length > 0) {
          let obj = this.radioGroup.find(o => o.optionValue === this.value)
          return obj
        } else {
          return this.selectedRadio
        }
      },
      set(value) {
        this.$forceUpdate
        this.$emit('update:radio', value)
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
